import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { slideInDownAnimation } from '../../app/app.animation';
import {
  IUser,
  IExternalData,
  IFormRequestInt,
  IFormRequestExt,
  ErrorParseService,
  PermissionsService,
} from '../../commons';
import { LGEDataService } from '../../commons';
import { Router } from '@angular/router';
// import { FormCCService } from '../../common/services';
import { Store } from '@ngrx/store';
import { Observable, of, Subscription } from 'rxjs';
import * as fromHome from './state/home.selectors';
import * as HomeAction from './state/home.actions';
import * as lgeApp from '../../app/state/app.actions';
import * as fromRoot from '../../app/state/app.selectors';
import * as AuthActions from '../login/state/login.actions';
import * as fromAuth from '../login/state/login.selectors';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

import { catchError, skipWhile, tap } from 'rxjs/operators';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import {
  HomeError,
  HomeLoading,
} from 'src/commons/interfaces/screens.interface';
import { HomeConstants } from 'src/app/app.constant';
import { ToastrService } from 'ngx-toastr';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'home-screen',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeScreenComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;
  @ViewChild('roleTabGroup', { static: true }) roleTabGroup: MatTabGroup;
  @ViewChild('adminTabGroup', { static: true }) adminTabGroup: MatTabGroup;
  @Input()
  private pending$!: Observable<HomeLoading[]>;
  private pendingSubscription!: Subscription;
  pending: FormGroup;

  @Input()
  private error$!: Observable<HomeError[]>;
  private errorSubscription!: Subscription;
  private error: HomeError[];

  @Input()
  private userIntData$!: Observable<IFormRequestInt | null>;
  private userIntDataSubscription!: Subscription;

  @Input()
  private userExtData$!: Observable<IFormRequestExt | null>;
  private userExtDataSubscription!: Subscription;

  @Input()
  private formCCExceptDraftData$!: Observable<IFormRequestInt | null>;
  private formCCExceptDraftDataSubscription!: Subscription;

  @Input()
  private formMGExceptDraftData$!: Observable<IFormRequestInt | null>;
  private formMGExceptDraftDataSubscription!: Subscription;

  @Input()
  private formCGExceptDraftData$!: Observable<IFormRequestExt | null>;
  private formCGExceptDraftDataSubscription!: Subscription;

  @Input()
  private formESExceptDraftData$!: Observable<IFormRequestExt | null>;
  private formESExceptDraftDataSubscription!: Subscription;

  @Input()
  private formPPExceptDraftData$!: Observable<IFormRequestExt | null>;
  private formPPExceptDraftDataSubscription!: Subscription;

  @Input()
  private formCCPendingApprovalData$!: Observable<IFormRequestInt | null>;
  private formCCPendingApprovalDataSubscription!: Subscription;

  @Input()
  private formCCApprovedData$!: Observable<IFormRequestInt | null>;
  private formCCApprovedDataSubscription!: Subscription;

  @Input()
  private formCGPendingApprovalData$!: Observable<IFormRequestExt | null>;
  private formCGPendingApprovalDataSubscription!: Subscription;

  @Input()
  private formCGApprovedData$!: Observable<IFormRequestExt | null>;
  private formCGApprovedDataSubscription!: Subscription;

  @Input()
  private formESPendingApprovalData$!: Observable<IFormRequestExt | null>;
  private formESPendingApprovalDataSubscription!: Subscription;

  @Input()
  private formESApprovedData$!: Observable<IFormRequestExt | null>;
  private formESApprovedDataSubscription!: Subscription;

  @Input()
  private formPPPendingApprovalData$!: Observable<IFormRequestExt | null>;
  private formPPPendingApprovalDataSubscription!: Subscription;

  @Input()
  private formPPApprovedData$!: Observable<IFormRequestExt | null>;
  private formPPApprovedDataSubscription!: Subscription;

  @Input()
  private externalProfileData$!: Observable<IExternalData | null>;
  private externalProfileDataSubscription!: Subscription;

  //temporary
  //temporary

  extEmailGroup!: FormGroup;
  userDetails: IUser | null;

  isAdmin = 'ADMIN';
  isApprover = 'APPROVER';
  isReviewer = 'REVIEWER';
  isFoundationCCCReviewer = false;
  isFoundationBODReviewer = false;
  isPFTPApprover = 'PFTPAPPROVER';

  // CC
  formCCDetails = [];

  formCCSubmittedDetails = [];

  pendingApprovalFormCCDetails = [];
  hasErrorPendingApprovalFormCCDetails: boolean = false;
  errorMessagePendingApprovalFormCCDetails!: string;

  approvedFormCCDetails = [];
  hasErrorApprovedFormCCDetails: boolean = false;
  errorMessageApprovedFormCCDetails!: string;

  // MG
  formMGSubmittedDetails = [];
  hasErrorFormMGSubmittedDetails: boolean = false;
  errorMessageFormMGSubmittedDetails: string | undefined;

  formExtDetails = [];
  // CG
  formCGSubmittedDetails = [];
  hasErrorFormCGSubmittedDetails: boolean = false;
  errorMessageFormCGSubmittedDetails!: string;

  pendingApprovalFormCGDetails = [];
  hasErrorPendingApprovalFormCGDetails: boolean = false;
  errorMessagePendingApprovalFormCGDetails!: string;

  approvedFormCGDetails = [];
  hasErrorApprovedFormCGDetails: boolean = false;
  errorMessageApprovedFormCGDetails!: string;

  pendingReviewalFormCGDetails = [];
  hasErrorPendingReviewalFormCGDetails: boolean = false;
  errorMessagePendingReviewalFormCGDetails!: string;

  reviewedFormCGDetails = [];
  hasErrorReviewedFormCGDetails: boolean = false;
  errorMessageReviewedFormCGDetails!: string;

  // ES
  formESSubmittedDetails = [];
  hasErrorFormESSubmittedDetails: boolean = false;
  errorMessageFormESSubmittedDetails!: string;

  pendingApprovalFormESDetails = [];
  hasErrorPendingApprovalFormESDetails: boolean = false;
  errorMessagePendingApprovalFormESDetails!: string;

  approvedFormESDetails = [];
  hasErrorApprovedFormESDetails: boolean = false;
  errorMessageApprovedFormESDetails!: string;

  pendingReviewalFormESDetails = [];
  hasErrorPendingReviewalFormESDetails: boolean = false;
  errorMessagePendingReviewalFormESDetails!: string;

  reviewedFormESDetails = [];
  hasErrorReviewedFormESDetails: boolean = false;
  errorMessageReviewedFormESDetails!: string;

  // PP
  formPPSubmittedDetails = [];
  hasErrorFormPPSubmittedDetails: boolean = false;
  errorMessageFormPPSubmittedDetails!: string;

  pendingApprovalFormPPDetails = [];
  hasErrorPendingApprovalFormPPDetails = false;
  errorMessagePendingApprovalFormPPDetails!: string;

  approvedFormPPDetails = [];
  hasErrorApprovedFormPPDetails = false;
  errorMessageApprovedFormPPDetails!: string;

  columnsForIntFormCC = [
    'select',
    'requestNo',
    'formName',
    'orgName',
    'subsection',
    'dateRequest',
    'status',
    'approverName',
    'title',
    'comment',
    'print', 'view'
  ];
  columnsForFormExtDetails = [
    'requestNo',
    'grantName',
    'PEName',
    'orgName',
    'subsection',
    'dateRequest',
    'status',
    'print', 'view'
  ];

  columnsForFormCCDetails = [
    'select',
    'requestNo',
    'formName',
    'orgName',
    'subsection',
    'dateRequest',
    'amount',
    'status',
    'approverName',
    'title',
    'comment',
    'print', 'view'
  ];
  columnsForFormCCApproval = [
    'requestNo',
    'formName',
    'orgName',
    'subsection',
    'dateRequest',
    'status',
    'print', 'view'
  ];

  columnsForExtCGPPSelectionExceptDraft = [
    'select',
    'requestNo',
    'grantName',
    'projectName',
    'orgName',
    'subsection',
    'dateRequest',
    'amount',
    'status',
    'statusAdmin',
    'comment',
    'print', 'view'
  ];
  columnsForExtESSelectionExceptDraft = [
    'select',
    'requestNo',
    'grantName',
    'eventName',
    'orgName',
    'subsection',
    'dateRequest',
    'amount',
    'status',
    'statusAdmin',
    'comment',
    'print', 'view'
  ];

  columnsForExtCGPPApproval = [
    'requestNo',
    'grantName',
    'projectName',
    'orgName',
    'subsection',
    'dateRequest',
    'statusApproval',
    'comment',
    'print', 'view'
  ];
  columnsForExtESApproval = [
    'requestNo',
    'grantName',
    'eventName',
    'orgName',
    'subsection',
    'dateRequest',
    'statusApproval',
    'comment',
    'print', 'view'
  ];

  isInternal = false;
  isExternalApproverReviewer = false;
  isNameReady = false;
  externalName: any = null;
  home!: FormGroup;
  isProfileExpired: boolean = false;
  isProfileVerifying: boolean = false;
  externalData: any;

  constructor(
    private store: Store<fromRoot.AppState>,
    private storeAuth: Store<fromAuth.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private errorParse: ErrorParseService,
    private _dataService: LGEDataService,
    private permissionsService: PermissionsService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.isInternal = this.permissionsService.isInternal();
    this.isExternalApproverReviewer =
      this.permissionsService.hasExternalApproverReviewerRoles();
    this.userDetails = this._dataService.getEmployeeDetails();
    this.createForms();
    this.isFoundationBODReviewer = this.hasRole('FOUNDATIONBODREVIEWER');
    this.isFoundationCCCReviewer = this.hasRole('FOUNDATIONCCCREVIEWER');
  }

  ngOnInit() {
    this.selectState();
    if (this.isInternal) {
      this.store.dispatch(new HomeAction.LoadUserIntState());
      this.GetInvoiceStatus();
      if (this.hasRole('ADMIN')) {
        this.store.dispatch(new HomeAction.LoadFormCCExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormMGExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormCGExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormESExceptDraftState());
        this.store.dispatch(new HomeAction.LoadFormPPExceptDraftState());
        // this.store.dispatch(new HomeAction.LoadFormCIExceptDraftState());
        // this.store.dispatch(new HomeAction.LoadFormFOExceptDraftState());
      }
      // form CC
      if (this.hasRole('APPROVER')) {
        this.store.dispatch(new HomeAction.LoadFormCCPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormCCApprovedState());
      }
      //form CG, ES
      if (this.hasRole('CITAPPROVER|FOUNDATIONAPPROVER')) {
        this.store.dispatch(new HomeAction.LoadFormCGPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormCGApprovedState());

        this.store.dispatch(new HomeAction.LoadFormESPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormESApprovedState());
      }
      // form PP
      if (this.hasRole('PFTPAPPROVER')) {
        this.store.dispatch(new HomeAction.LoadFormPPPendingApprovalState());
        this.store.dispatch(new HomeAction.LoadFormPPApprovedState());
      }

      // //form CI
      // if (this.hasRole('CITAPPROVER')) {
      //     this.store.dispatch(new HomeAction.LoadFormCIPendingApprovalState());
      //     this.store.dispatch(new HomeAction.LoadFormCIApprovedState());
      // }
      // //form FO
      // if (this.hasRole('FOUNDATIONAPPROVER')) {
      //     this.store.dispatch(new HomeAction.LoadFormFOPendingApprovalState());
      //     this.store.dispatch(new HomeAction.LoadFormFOApprovedState());
      // }
    } else {
      this.store.dispatch(new HomeAction.LoadUserExtState());
      // this.storeAuth.dispatch(new AuthActions.LoadExternalProfileState());
    }
  }

  ngAfterViewInit(): void {
    this.isNameReady = false;
    this.extEmailGroup = this.fb.group({
      extEmail: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(254),
          Validators.pattern(
            new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
          ),
        ],
      ],
    });
    this.startSubscriptions();

    if (
      this.hasRole(
        'CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV'
      )
    ) {
      this.getPendingReviewalFormCGDetails();
      this.getPendingReviewalFormESDetails();
    }
  }

  GetInvoiceStatus() {
    return this._dataService.GetInvoiceStatus().pipe(
      tap(() => console.log('GetInvoiceStatus Success')),
      catchError((err: Error) => of(err))
    );
    // .then(data => {
    //     resolve('done');
    // }, (error:Error) => {
    //     resolve('done');
    // });
    // });
  }

  getPendingReviewalFormCGDetails() {
    let data: any = {};
    data.approvalStatus = 'PendingReviewal';
    data.status = 'PendingReviewal';
    this._dataService.GetFormCGPendingOrApproved(data).subscribe({
      next: (data) => {
        if (data) {
          this.pendingReviewalFormCGDetails = this.updateStatusDescription(
            data.filter(
              (m: { dateRequest: moment.MomentInput }) =>
                moment(m.dateRequest, 'MM-DD-YYYY') >
                moment('09-30-2020', 'MM-DD-YYYY')
            )
          );
          this.ref.markForCheck();
        }
      },
      error: (error: Error) => {
        this.hasErrorPendingApprovalFormCGDetails = true;
        this.errorMessagePendingReviewalFormCGDetails = `Error! ${error.message}`;
        this.ref.markForCheck();
      },
    });
  }

  getPendingReviewalFormESDetails() {
    let data: any = {};
    data.approvalStatus = 'PendingReviewal';
    data.status = 'PendingReviewal';
    this._dataService.GetFormESPendingOrApproved(data).subscribe({
      next: (data) => {
        if (data) {
          this.pendingReviewalFormESDetails = this.updateStatusDescription(
            data.filter(
              (m: { dateRequest: moment.MomentInput }) =>
                moment(m.dateRequest, 'MM-DD-YYYY') >
                moment('09-30-2020', 'MM-DD-YYYY')
            )
          );
          this.ref.markForCheck();
        }
      },
      error: (error: Error) => {
        this.hasErrorPendingApprovalFormESDetails = true;
        this.errorMessagePendingReviewalFormESDetails = `Error! ${error.message}`;
        this.ref.markForCheck();
      },
    });
  }

  selectRow(row: any) {
    this._dataService.setApprovedFormCCData(row.formccId);
    this.router.navigate([
      `charity-forms/charitable-contribution/${row.formccId}`,
    ]);
  }

  selectApprovarRow(row: any) {
    this._dataService.setpendingApprovalFormCCData(row);
    this.router.navigate([
      `charity-forms/charitable-contribution/${row.formccId}`,
    ]);
  }

  getStatusClass(status: string) {
    const possibleStatus = [
      'Submitted',
      'Pending',
      'Draft',
      'Approved',
      'Pending Approval',
      'Rejected',
      'Sent To Oracle',
      'Waiting For Oracle',
      'Withdrawn',
      'Paid Credit',
      'Check Cashed',
      'Check Issued',
      'Check Voided',
      'Check Cleared',
      'Cancelled',
      'Reassign to CI',
      'Pending VP,CR & CA Approval',
    ];
    return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
  }

  hasRole(role: string) {
    return this.permissionsService.hasRoles(role);
  }
  hasApproverRole() {
    return this.permissionsService.hasApproverRole();
  }
  // Select state
  private selectState(): void {
    this.pending$ = this.store.select(fromHome.getHomeScreenPending);
    if (!this.isInternal) {
      this.userExtData$ = this.store
        .select(fromHome.getUserExt)
        .pipe(skipWhile((data) => data === undefined || data === null));
      this.externalProfileData$ = this.store
        .select(fromAuth.getExternalProfile)
        .pipe(
          skipWhile((profile: IExternalData) => {
            return profile === undefined || profile === null;
          })
        );
    } else {
      this.userIntData$ = this.store
        .select(fromHome.getUserInt)
        .pipe(skipWhile((data) => data === undefined || data === null));
      if (this.hasRole('ADMIN')) {
        this.formCCExceptDraftData$ = this.store
          .select(fromHome.getFormCCExceptDraft)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formMGExceptDraftData$ = this.store
          .select(fromHome.getFormMGExceptDraft)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formCGExceptDraftData$ = this.store
          .select(fromHome.getFormCGExceptDraft)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formESExceptDraftData$ = this.store
          .select(fromHome.getFormESExceptDraft)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formPPExceptDraftData$ = this.store
          .select(fromHome.getFormPPExceptDraft)
          .pipe(skipWhile((data) => data == undefined || data == null));
        // this.formCIExceptDraftData$ = this.store.select(fromHome.getFormCIExceptDraft).pipe(skipWhile(data => (data === undefined || data === null)));
        // this.formFOExceptDraftData$ = this.store.select(fromHome.getFormFOExceptDraft).pipe(skipWhile(data => (data === undefined || data === null)));
      }
      if (this.hasRole('APPROVER')) {
        this.formCCPendingApprovalData$ = this.store
          .select(fromHome.getFormCCPendingApproval)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formCCApprovedData$ = this.store
          .select(fromHome.getFormCCApproved)
          .pipe(skipWhile((data) => data === undefined || data === null));
      }
      if (this.hasRole('FOUNDATIONAPPROVER|CITAPPROVER')) {
        this.formCGPendingApprovalData$ = this.store
          .select(fromHome.getFormCGPendingApproval)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formCGApprovedData$ = this.store
          .select(fromHome.getFormCGApproved)
          .pipe(skipWhile((data) => data === undefined || data === null));

        this.formESPendingApprovalData$ = this.store
          .select(fromHome.getFormESPendingApproval)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formESApprovedData$ = this.store
          .select(fromHome.getFormESApproved)
          .pipe(skipWhile((data) => data === undefined || data === null));
      }
      if (this.hasRole('PFTPAPPROVER')) {
        this.formPPPendingApprovalData$ = this.store
          .select(fromHome.getFormPPPendingApproval)
          .pipe(skipWhile((data) => data === undefined || data === null));
        this.formPPApprovedData$ = this.store
          .select(fromHome.getFormPPApproved)
          .pipe(skipWhile((data) => data === undefined || data === null));
      }
    }
    this.error$ = this.store.select(fromHome.getHomeScreenError);
    // .pipe(skipWhile((error) => error === undefined || error === null || error[1] === ''));
  }

  // private displayLoader(pending: boolean): void {
  //     if (pending) {
  //         this.ams.closeDialog();
  //         setTimeout(() => {
  //             this.ams.showLoader('Loading...');
  //             this.ref.markForCheck();
  //         })
  //     } else {
  //         this.ams.closeDialog().then(() => {
  //             if (this.error !== null && this.error !== undefined) {
  //                 this.displayError(this.error);
  //             } else if (this.isProfileExpired && !this.isProfileVerifying) {

  //             }
  //         });
  //     }
  // }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.closeDialog();
    // this.ams.showAlert('Loading Error', errorMessage);
    this.toastr.error(errorMessage);
    this.ref.markForCheck();
  }

  // Create reactive forms
  private createForms(): void {
    this.home = this.fb.group({
      UserInt: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      UserExt: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),

      FormCCExceptDraft: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormMGExceptDraft: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormCGExceptDraft: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormESExceptDraft: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormPPExceptDraft: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),

      FormCCPendingApproval: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormCCApproved: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),

      FormCGPendingApproval: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormCGApproved: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),

      FormESPendingApproval: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormESApproved: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),

      FormPPPendingApproval: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
      FormPPApproved: this.fb.group({
        hasError: [false],
        errorMessage: [''],
      }),
    });
    const pending: any = {};
    HomeConstants.forEach((item) => {
      pending[item] = new FormControl(false);
    });
    this.pending = new FormGroup(pending);
  }

  updateStatusDescription = (data: any) => {
    let result = data.map((value: any) => {
      switch (value.statusDescrAdmin) {
        case 'Negotiable':
          return {
            ...value,
            statusDescrAdmin: 'Check Issued',
          };

        case 'Voided':
          return {
            ...value,
            statusDescrAdmin: 'Check Voided',
          };

        case 'Cleared':
          return {
            ...value,
            statusDescrAdmin: 'Check Cleared',
          };

        case 'Reconciled':
          return {
            ...value,
            statusDescrAdmin: 'Check Cashed',
          };
        default:
          return { ...value };
      }
      // return value;
    });
    result = result.map((value) => {
      switch (value.status) {
        case 'PendingApproval':
          return {
            ...value,
            status: 'Pending Approval',
          };

        case 'Negotiable':
          return {
            ...value,
            status: 'Check Cashed',
          };

        case 'Voided':
          return {
            ...value,
            status: 'Check Voided',
          };

        case 'Cleared':
          return {
            ...value,
            status: 'Check Cleared',
          };

        case 'Reconciled':
          return {
            ...value,
            status: 'Check Cashed',
          };
        default:
          return { ...value };
      }
    });
    return result;
  };
  // Opens sidenav if on mobile
  openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }

  // Subscribe to state data and mark it for changes
  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      data.forEach((item) => {
        const form = item.form;
        this.pending.get(item.form).setValue(item.isLoading);
      });
      this.ref.markForCheck();
      // this.pending = data;
      // this.ref.markForCheck();
    });

    this.errorSubscription = this.error$.subscribe((data: HomeError[]) => {
      if (data !== null && data !== undefined) {
        data.forEach((item) => {
          this.home.get([item.form, 'hasError']).setValue(item.hasError);
          this.home
            .get([item.form, 'errorMessage'])
            .setValue(item.errorMessage);
          this.ref.markForCheck();
        });
      }
      // this.error = data;
      // this.home.get([data[0], 'hasError']).setValue(true);
      // this.home.get([data[0], 'errorMessage']).setValue(this.error.message);
      // this.ref.markForCheck();
    });

    if (this.isInternal) {
      this.userIntDataSubscription = this.userIntData$.subscribe((data) => {
        if (data !== undefined) {
          this.formCCDetails = this.updateStatusDescription(data);
          this.ref.markForCheck();
        }
      });

      if (this.hasRole('ADMIN')) {
        this.formCCExceptDraftDataSubscription =
          this.formCCExceptDraftData$.subscribe((data) => {
            if (data !== undefined) {
              this.formCCSubmittedDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formMGExceptDraftDataSubscription =
          this.formMGExceptDraftData$.subscribe((data) => {
            if (data !== undefined) {
              this.formMGSubmittedDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formCGExceptDraftDataSubscription =
          this.formCGExceptDraftData$.subscribe((data) => {
            if (data !== undefined) {
              this.formCGSubmittedDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formESExceptDraftDataSubscription =
          this.formESExceptDraftData$.subscribe((data) => {
            if (data !== undefined) {
              this.formESSubmittedDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formPPExceptDraftDataSubscription =
          this.formPPExceptDraftData$.subscribe((data) => {
            if (data !== undefined) {
              this.formPPSubmittedDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });

        // this.formCIExceptDraftDataSubscription = this.formCIExceptDraftData$
        //     .subscribe(data => {
        //         if (data !== undefined) {
        //             this.formCISubmittedDetails = this.updateStatusDescription(data);
        //             this.ref.markForCheck();
        //         }
        //     });
        // this.formFOExceptDraftDataSubscription = this.formFOExceptDraftData$
        //     .subscribe(data => {
        //         if (data !== undefined) {
        //             this.formFOSubmittedDetails = this.updateStatusDescription(data);
        //             this.ref.markForCheck();
        //         }
        //     });
      }

      if (this.hasRole('APPROVER')) {
        this.formCCPendingApprovalDataSubscription =
          this.formCCPendingApprovalData$.subscribe((data) => {
            if (data !== undefined) {
              this.pendingApprovalFormCCDetails =
                this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formCCApprovedDataSubscription =
          this.formCCApprovedData$.subscribe((data) => {
            if (data !== undefined) {
              this.approvedFormCCDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
      }

      if (this.hasRole('FOUNDATIONAPPROVER|CITAPPROVER')) {
        this.formCGPendingApprovalDataSubscription =
          this.formCGPendingApprovalData$.subscribe((data) => {
            if (data !== undefined) {
              this.pendingApprovalFormCGDetails =
                this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formCGApprovedDataSubscription =
          this.formCGApprovedData$.subscribe((data) => {
            if (data !== undefined) {
              this.approvedFormCGDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });

        this.formESPendingApprovalDataSubscription =
          this.formESPendingApprovalData$.subscribe((data) => {
            if (data !== undefined) {
              this.pendingApprovalFormESDetails =
                this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formESApprovedDataSubscription =
          this.formESApprovedData$.subscribe((data) => {
            if (data !== undefined) {
              this.approvedFormESDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
      }

      if (this.hasRole('PFTPAPPROVER')) {
        this.formPPPendingApprovalDataSubscription =
          this.formPPPendingApprovalData$.subscribe((data) => {
            if (data !== undefined) {
              this.pendingApprovalFormPPDetails =
                this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
        this.formPPApprovedDataSubscription =
          this.formPPApprovedData$.subscribe((data) => {
            if (data !== undefined) {
              this.approvedFormPPDetails = this.updateStatusDescription(data);
              this.ref.markForCheck();
            }
          });
      }
    } else {
      this.userExtDataSubscription = this.userExtData$.subscribe((data) => {
        if (data !== undefined) {
          this.formExtDetails = this.updateStatusDescription(data);
          // this.ams.showLoader("Validating your Organization's EIN ...");
          this.isProfileVerifying = true;
          this._dataService.CharityCheck(this.externalData.orgInfoExt.EIN).pipe(
            tap((result: any) => {
              this.isProfileVerifying = false;
              if (result === 'invalid' || result === 'Expired') {
                this.ams.closeDialog();
                this.ams.showAlert(
                  'Unable to verify!',
                  'Your organization information and tax-exempt status cannot be verified. Please contact contributions@lge-ku.com with questions.'
                );
                this.ref.markForCheck();
                this.ams.alert.afterClosed().subscribe((result: string) => {
                  let externalData = JSON.parse(
                    JSON.stringify(this.externalData)
                  );
                  if (externalData.externalUser.accessStatus !== 'pendingEIN') {
                    externalData.externalUser.accessStatus = 'pendingEIN';
                    externalData.externalUser.isVerified =
                      result === 'invalid' ? 0 : 2;
                    // this.ams.showLoader('Loading...');
                    this._dataService
                      .externalProfileEditDetails(externalData)
                      .pipe(
                        tap((result: any) => {
                          this.storeAuth.dispatch(
                            new AuthActions.LoadExternalProfileState()
                          );
                          setTimeout(() => {
                            this.ams.closeDialog();
                            this.ref.markForCheck();
                          }, 100);
                        })
                      );
                  }
                });
              } else {
                let externalData = JSON.parse(
                  JSON.stringify(this.externalData)
                );
                externalData.externalUser.isVerified = 1;
                externalData.orgInfoExt.name = result.organization_name;
                externalData.orgInfoExt.subsection_501 = result.subsection_501;
                // this.ams.showLoader('Loading...');
                this._dataService.externalProfileEditDetails(externalData).pipe(
                  tap(() => {
                    this.storeAuth.dispatch(
                      new AuthActions.LoadExternalProfileState()
                    );
                    setTimeout(() => {
                      this.ams.closeDialog();
                      this.ref.markForCheck();
                    }, 100);
                  })
                );
              }
            }),
            catchError((error: Error) => {
              this.isProfileVerifying = false;
              if (
                error.message.includes('invalid') ||
                error.message.includes('Expired')
              ) {
                this.ams.closeDialog();
                this.ams.showAlert(
                  'Unable to verify!',
                  'Your organization information and tax-exempt status cannot be verified. Please contact contributions@lge-ku.com with questions.'
                );
                this.ref.markForCheck();
                this.ams.alert.afterClosed().subscribe((result: any) => {
                  let externalData = JSON.parse(
                    JSON.stringify(this.externalData)
                  );
                  if (externalData.externalUser.accessStatus !== 'pendingEIN') {
                    externalData.externalUser.accessStatus = 'pendingEIN';
                    externalData.externalUser.isVerified =
                      result === 'invalid' ? 0 : 2;
                    // this.ams.showLoader('Loading...');
                    this._dataService
                      .externalProfileEditDetails(externalData)
                      .pipe(
                        tap((result: any) => {
                          this.storeAuth.dispatch(
                            new AuthActions.LoadExternalProfileState()
                          );
                          setTimeout(() => {
                            this.ams.closeDialog();
                            this.ref.markForCheck();
                          }, 100);
                        })
                      );
                  }
                });
              } else {
                this.ams.closeDialog();
                this.ams.showAlert(
                  'Unable to verify!',
                  `Please contact contributions@lge-ku.com with questions.\n ${error.message}`
                );
                this.ref.markForCheck();
              }
              return of(error);
            })
          );
          this.ref.markForCheck();
        }
      });

      this.externalProfileDataSubscription =
        this.externalProfileData$.subscribe((data) => {
          if (data !== null) {
            this.externalData = data;
            this.isProfileExpired = data.externalUser.isVerified !== 1;
          }
          this.ref.markForCheck();
        });
    }
  }

  // Unsubscribe from state data changes
  private endSubscriptions(): void {
    this.pendingSubscription?.unsubscribe();
    this.errorSubscription?.unsubscribe();
    if (this.isInternal) {
      this.userIntDataSubscription?.unsubscribe();
      this.formCCExceptDraftDataSubscription?.unsubscribe();
      this.formMGExceptDraftDataSubscription?.unsubscribe();
      this.formCGExceptDraftDataSubscription?.unsubscribe();
      this.formESExceptDraftDataSubscription?.unsubscribe();
      this.formPPExceptDraftDataSubscription?.unsubscribe();
      this.formCCApprovedDataSubscription?.unsubscribe();
      this.formCGPendingApprovalDataSubscription?.unsubscribe();
      this.formCGApprovedDataSubscription?.unsubscribe();

      this.formESPendingApprovalDataSubscription?.unsubscribe();
      this.formESApprovedDataSubscription?.unsubscribe();
      this.formPPPendingApprovalDataSubscription?.unsubscribe();
      this.formPPApprovedDataSubscription?.unsubscribe();
    } else {
      this.userExtDataSubscription?.unsubscribe();
      this.externalProfileDataSubscription?.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.endSubscriptions();
    this.store.dispatch(new HomeAction.LoadHomeStateInit());
  }
}
